import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CookieService {
  constructor() {}

  setSessionId() {
    const sessionId = crypto.randomUUID();
    document.cookie = `SessionId=${sessionId}; path=/; SameSite=Lax`;
  }

  getSessionId(): string | null {
    return this.get('SessionId') || null;
  }

  get(name: string): string {
    const encodedName = encodeURIComponent(name);
    const regExp: RegExp = this.getCookieRegExp(encodedName);
    const result = regExp.exec(document.cookie);
    return result ? decodeURIComponent(result[1]) : '';
  }

  check(name: string): boolean {
    name = encodeURIComponent(name);
    const regExp: RegExp = this.getCookieRegExp(name);
    const exists: boolean = regExp.test(document.cookie);
    return exists;
  }

  private getCookieRegExp(name: string): RegExp {
    const escapedName: string = name.replace(
      /([\[\]\{\}\(\)\|\=\;\+\?\,\.\*\^\$])/gi,
      '\\$1'
    );
    return new RegExp(
      '(?:^' + escapedName + '|;\\s*' + escapedName + ')=(.*?)(?:;|$)',
      'g'
    );
  }

  /**
   * @param name     Cookie name
   * @param value    Cookie value
   * @param expires  Number of hours until the cookie expires or an actual `Date`
   * @param path     Cookie path
   * @param domain   Cookie domain
   * @param secure   Secure flag
   * @param sameSite OWASP samesite token `Lax` or `Strict`
   */
  set(
    name: string,
    value: string,
    expires?: number | Date,
    path?: string,
    domain?: string,
    secure?: boolean,
    sameSite?: 'Lax' | 'Strict',
    encode?: (val: string) => string
  ): void {
    const valueEncoded = encode ? encode(value) : encodeURIComponent(value);

    let cookieString: string =
      encodeURIComponent(name) + '=' + valueEncoded + ';';
    if (expires) {
      if (typeof expires === 'number') {
        if (expires !== 0) {
          const dateExpires: Date = new Date(
            new Date().getTime() + expires * 1000 * 60 * 60
          );
          cookieString += 'expires=' + dateExpires.toString() + ';';
        }
      } else {
        cookieString += 'expires=' + expires.toString() + ';';
      }
    }
    if (path) {
      cookieString += 'path=' + path + ';';
    }
    if (domain) {
      cookieString += 'domain=' + domain + ';';
    }
    if (secure) {
      cookieString += 'secure;';
    }
    if (sameSite) {
      cookieString += 'sameSite=' + sameSite + ';';
    }
    document.cookie = cookieString;
  }
}
